<div class="container">
  <div *ngIf="actu" class="box mb-3">
    <img [src]="getPictureUrl(actu)" />
    <div class="content">
      <div class="title h4">{{ actu.title }}</div>
      <div class="date">{{ actu.pubStart|date:'dd/MM/y' }}</div>
    </div>
  </div>
  <div class="description" [innerHTML]="actu.description"></div>
</div>